var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGateOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke-only",
    d: "M13.48 13.34v-1.37m-2.89 1.37v-1.37m5.85 0V21H20V4h-2.8v2.5h-1.64V4h-2.8v2.5h-1.52V4h-2.8v2.5H6.8V4H4v17h3.68V11.97m8.76 0h-2.96m2.96 0a2.43 2.43 0 0 0-2.42-2.45h-.54m-5.8 2.45h2.91m-2.9 0a2.43 2.43 0 0 1 2.41-2.45h.5m2.88 2.45h-2.89m2.89 0V9.52m-2.89 2.45V9.52m0 0h2.89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGateOpen);
export default __webpack_public_path__ + "static/media/gate-open.ee1627cb3c9a1abf0df6add9dfcb45b3.svg";
export { ForwardRef as ReactComponent };